import { useState } from "react";
import { Navigate } from "react-router-dom";
import { useAdmin } from "@/context/AdminContext";
import { LogoWordmark } from "@/components/site/Logo";

export default function AdminLogin() {
  const { admin, login } = useAdmin();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (admin) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    const res = await login(email, password);
    if (!res.ok) setError(res.error);
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-[#080808] flex items-center justify-center px-6 grain relative" data-testid="admin-login-page">
      <div className="w-full max-w-sm">
        <div className="flex justify-center mb-10"><LogoWordmark /></div>
        <form onSubmit={submit} className="gold-hairline bg-[#0D0D0D] p-8 space-y-5">
          <h1 className="font-serif-display text-2xl text-white text-center">Owner Sign In</h1>
          {error && <p className="font-sans-body text-xs text-red-400 text-center" data-testid="admin-login-error">{error}</p>}
          <div>
            <label className="font-sans-body text-[10px] uppercase tracking-[0.25em] text-[#C6A15B] block mb-2">Email</label>
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              className="w-full bg-transparent border border-[#D4AF37]/25 px-4 py-3 font-sans-body text-sm text-white focus:outline-none focus:border-[#D4AF37]"
              data-testid="admin-email-input" />
          </div>
          <div>
            <label className="font-sans-body text-[10px] uppercase tracking-[0.25em] text-[#C6A15B] block mb-2">Password</label>
            <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
              className="w-full bg-transparent border border-[#D4AF37]/25 px-4 py-3 font-sans-body text-sm text-white focus:outline-none focus:border-[#D4AF37]"
              data-testid="admin-password-input" />
          </div>
          <button type="submit" className="btn-gold w-full" disabled={loading} data-testid="admin-login-button">
            {loading ? "Signing in..." : "Sign In"}
          </button>
        </form>
        <p className="text-center font-sans-body text-[11px] text-[#666666] mt-6">
          Private area for the store owner only.
        </p>
      </div>
    </div>
  );
}
